const menu = {
    label: 'Usuários',
    icon: 'pi pi-fw pi-users',
    to: '/senac/usuarios',
    rules: ['SENAC-USUARIOS-00'],
};

export default menu;
